//import update from 'immutability-helper';

const emptyState = {
}

const NotFoundPageReducer = (state = emptyState, action) => {
  switch (action.type) {
    default: {
      return state
    }
  }
}

export default NotFoundPageReducer